import { render, staticRenderFns } from "./PerfilUser.vue?vue&type=template&id=4dd071a2&scoped=true"
import script from "./PerfilUser.vue?vue&type=script&lang=js"
export * from "./PerfilUser.vue?vue&type=script&lang=js"
import style0 from "./PerfilUser.vue?vue&type=style&index=0&id=4dd071a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd071a2",
  null
  
)

export default component.exports